import React from "react";
import {Redirect, Route, Router, Switch} from "react-router-dom";
import {HelmetProvider} from "react-helmet-async";
import Login from "./Screens/Login";
import Registration from "./Screens/Registration";
import BasicRegistration from "./Screens/BasicRegistration";
import Main from "./Screens/Main";
import {is_logged_in} from '../util/auth'
import history from '../util/history'
import {loadStripe} from '@stripe/stripe-js';
import {Elements} from '@stripe/react-stripe-js';

const stripePromise = loadStripe('pk_live_51INkvMK3zRtQ0Cz5lWTdgGHuQTLm7SyNDMePrE07bq2dVo2ZSZeHPiYvxH5waUDi9sNaWoHjrOfBVkNy8U0XpS2F00jBWCqqdZ');

export default function App() {
    return (
        <>
            <HelmetProvider>
                <Router history={history}>
                    <Switch>
                        <Route path="/login"
                               render={() => {
                                   if (is_logged_in()) {
                                       return <Redirect to="/"/>
                                   }

                                   return <Login/>
                               }}
                        />
                        <Route path="/register"
                               render={() => {
                                   if (is_logged_in()) {
                                       return <Redirect to="/"/>
                                   }
                                   return <Elements stripe={stripePromise}><Registration/></Elements>
                               }}
                        />
                        <Route path="/register-student/"
                               render={(props) => {
                                   if (is_logged_in()) {
                                       return <Redirect to="/"/>
                                   }
                                   return <BasicRegistration {...props} />
                               }}
                        />
                        <Route path="/"
                               render={() => {
                                   if (!is_logged_in()) {
                                       return <Redirect to="/register"/>
                                   }
                                   return <Elements stripe={stripePromise}><Main/></Elements>
                               }}
                        />
                    </Switch>
                </Router>
            </HelmetProvider>
        </>
    )
}
